module.exports = new __parcel__URL__("bossfight_title_text.b8bdb9e2.png").toString();